import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTopNavbar } from "../../Reducers/actions/navbarActions";
import { getPaginatedPayments } from "../../Reducers/actions/paymentActions";
import { PaymentSummaryRowSkeleton } from "../../components/Skeletons/FinanceListSkeletons";
import PaymentSummary from "./PaymentSummary";

import "./PaymentHistoryList.scss"

function PaymentHistoryList() {
    const dispatch = useDispatch();

    const { auth_user_id, payments, paymentsLoading } = useSelector((state) => ({
        auth_user_id: state.auth.user?.user_id,
        paymentsLoading: state?.payments?.loading,
        payments: state?.payments?.payments,
    }));

    useEffect(() => {
        if (!auth_user_id) return;
        dispatch(getPaginatedPayments(0, 100, auth_user_id));
        dispatch(setTopNavbar({ showBackArrow: true, title: "All Payments" }));
    }, [auth_user_id]);

    if (paymentsLoading) {
        return (
            <div className="mt-24 px-16 payments-list-container" role="status" aria-label="Loading payments">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                    <PaymentSummaryRowSkeleton key={i} />
                ))}
            </div>
        );
    }

    return (
        <div className="mt-24 px-16 payments-list-container">
            {payments.map((payment) => (
                <PaymentSummary key={payment?.id} payment={payment} variant="paymentHistory" />
            ))}
        </div>
    );
}

export default PaymentHistoryList;
